module.exports = __webpack_public_path__ + "static/img/top-img.b1b8a03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/top-img.jpg
// module id = We31
// module chunks = 1